(() => {
  window.initSlimieeWheel = (root, controls) => {
    const $ = selector => root.querySelector(selector);
    const overlay = $('#couponWheelOverlay');
    if (!overlay || overlay.dataset.wheelReady) return;
    overlay.dataset.wheelReady = 'true';
    const wheel = $('#couponWheel');
    const spin = $('#couponWheelSpin');
    const copy = $('#couponWheelCopy');
    const result = $('#couponWheelResult');
    const prizes = [...root.querySelectorAll('[data-wheel-prize]')].map((el,index) => ({
      index, key:el.dataset.prize, label:el.dataset.label, code:(el.dataset.code || '').trim(), loss:el.dataset.loss === 'true'
    }));
    const eligible = prizes.filter(p => p.loss || p.code || controls.preview);
    const ready = controls.preview || eligible.some(p => !p.loss);
    const storageKey = 'slimiee-wheel-v2:' + location.host;
    const emailStorageKey = 'slimiee-wheel-email-v2:' + location.host;
    const emailForm = $('#wheelEmailForm');
    const emailInput = $('#couponWheelEmail');
    const consent = $('#wheelEmailConsent');
    const emailSubmit = $('#wheelEmailSubmit');
    let unlocked = !!root.querySelector('[data-wheel-email-confirmed]');
    try {
      unlocked = unlocked || sessionStorage.getItem(emailStorageKey) === 'accepted';
      if (unlocked) sessionStorage.setItem(emailStorageKey, 'accepted');
    } catch {}
    let chosen = null;
    let spinning = false;
    try {
      const previous = sessionStorage.getItem(storageKey);
      chosen = prizes.find(p => p.key === previous) || null;
    } catch {}
    const angle = p => 1800 + 360 - (p.index * 45 + 22.5);
    function reveal() {
      spinning = false;
      spin.hidden = true;
      copy.hidden = chosen.loss || !chosen.code || controls.preview;
      result.textContent = chosen.loss ? 'No luck this time. Thanks for taking a spin!' : `You landed on ${chosen.label.toLowerCase()}!${controls.preview ? ' Preview result.' : ' Use your code at checkout.'}`;
      copy.textContent = `CODE: ${chosen.code} · COPY`;
      wheel.removeAttribute('aria-busy');
    }
    function updateGate() {
      overlay.dataset.emailLocked = String(!unlocked);
      overlay.dataset.prizesReady = String(!!ready);
      $('#wheelEmailGate').hidden = unlocked;
      emailInput.disabled = !ready;
      consent.disabled = !ready;
      spin.hidden = !unlocked || !!chosen;
      spin.disabled = !ready || !unlocked || spinning;
      if (!unlocked && ready) result.textContent = 'Enter your email to unlock your spin.';
      if (emailSubmit) emailSubmit.disabled = !ready || !emailInput.validity.valid || !emailInput.value.trim() || !consent.checked;
      if (unlocked && !chosen && ready) result.textContent = 'You’re in! Spin to discover your offer.';
    }
    function restore() {
      updateGate();
      if (chosen && unlocked && !spinning) {
        wheel.style.transition = 'none';
        wheel.style.transform = `rotate(${angle(chosen)}deg)`;
        reveal();
      } else if (!ready) {
        spin.disabled = true;
        spin.textContent = 'OFFERS COMING SOON';
        result.textContent = 'New treats are on the way. Check back soon.';
      }
    }
    $('#couponWheelOpen').addEventListener('click', () => { restore(); controls.open(); });
    $('#couponWheelClose').addEventListener('click', () => controls.close());
    overlay.addEventListener('click', event => { if (event.target === overlay) controls.close(); });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !overlay.hidden) { event.preventDefault(); controls.close(); }
    });
    spin.addEventListener('click', () => {
      if (!ready || !unlocked || chosen || spinning) return;
      const random = crypto.getRandomValues(new Uint32Array(1))[0] / 4294967296;
      chosen = eligible[Math.floor(random * eligible.length)];
      spinning = true;
      // Persist immediately so closing the dialog cannot grant another spin.
      try { sessionStorage.setItem(storageKey, chosen.key); } catch {}
      spin.disabled = true;
      spin.textContent = 'SPINNING…';
      result.textContent = 'A little luck is on its way…';
      wheel.setAttribute('aria-busy','true');
      wheel.style.transition = '';
      wheel.style.transform = `rotate(${angle(chosen)}deg)`;
      setTimeout(reveal, matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 3250);
    });
    emailInput?.addEventListener('input', updateGate);
    consent?.addEventListener('change', updateGate);
    emailForm?.addEventListener('submit', event => {
      if (!ready) { event.preventDefault(); return; }
      if (!emailForm.checkValidity()) { event.preventDefault(); emailForm.reportValidity(); return; }
      if (controls.preview) {
        event.preventDefault();
        unlocked = true;
        // The local preview simulates signup without transmitting or retaining an email.
        try { sessionStorage.setItem(emailStorageKey, 'accepted'); } catch {}
        emailInput.value = '';
        restore();
      } else {
        emailSubmit.disabled = true;
        $('#wheelEmailStatus').textContent = 'Submitting your signup…';
      }
    });
    copy.addEventListener('click', async () => {
      if (!chosen?.code || chosen.loss || controls.preview) return;
      try { await navigator.clipboard.writeText(chosen.code); copy.textContent = `COPIED · ${chosen.code}`; }
      catch { copy.textContent = `YOUR CODE: ${chosen.code}`; }
    });
    restore();
    if (root.querySelector('[data-wheel-email-confirmed],[data-wheel-email-errors]')) controls.open();
  };
})();
